import React from "react";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { ActionsCreators } from "../../actions";
import strings from "../../helpers/Localization";

import Dialog from "@mui/material/Dialog";
import Modal from "../../aGlobalDesign/Modal/Modal";
import Inputs from "../../aGlobalDesign/Inputs/Inputs";
/*
Component containing an alert dialog box callable anywhere through redux
Ex: this.props.OpenDialog({
        title: "title",
        description: "description", REQUIRED
        secondaryLabel: "cancel",
        primaryLabel: "delete", REQUIRED
        onPrimaryAction: () => {
            // Your method
        },
        onSecondaryAction () => {
            // Your method
        },
        clickOutsideToClose: true
    });
*/

class AlertDialog extends React.Component {

    constructor() {
        super();
        this.state = {
            textField: ""
        };
    }

    onPrimaryAction() {
        if (this.props.alertDialog.onPrimaryAction) {this.props.alertDialog.onPrimaryAction(this.state.textField);}
        this.props.CloseDialog();
    }

    onSecondaryAction() {
        this.props.alertDialog.onSecondaryAction(this.state.textField);
        this.props.CloseDialog();
    }

    handleClose() {
        if (this.props.alertDialog.clickOutsideToClose) {
            this.setState({ textField: "" });
            if (this.props.alertDialog.onClose) {
                this.props.alertDialog.onClose();
            }
            this.props.CloseDialog();
        }
        else {
            return false;
        }
    }

    clearData() {
        this.setState({ textField: "" });
        this.props.ClearDialog();
    }

    render() {
        return (
            <Dialog open={this.props.alertDialog.isOpen} onClose={() => this.handleClose()}>
                <Modal open={this.props.alertDialog.isOpen}
                    onClose={() => this.onSecondaryAction() ? this.onSecondaryAction() : this.handleClose()}
                    title={this.props.alertDialog.title ? this.props.alertDialog.title : ""}
                    icon={"warning"}
                    isValidationRed = {this.props.alertDialog.primaryLabel === strings.confirmDelete || this.props.alertDialog.primaryLabel === strings.confirmLogout}
                    validationIcon={this.props.alertDialog.primaryLabel === strings.confirmDelete ? "trash" : this.props.alertDialog.primaryLabel === strings.confirmLogout ? "logout" : this.props.alertDialog.primaryLabel === strings.Restart ? "textUndo" : this.props.alertDialog.primaryLabel === strings.ToContinue ? "chevronRight" : null}
                    validationTitle={this.props.alertDialog.primaryLabel ? this.props.alertDialog.primaryLabel : strings.Validate}
                    hideClose={this.props.alertDialog.hideClose}
                    onValidate={() => this.onPrimaryAction()}
                    switchButtons={this.props.alertDialog.primaryLabel === strings.confirmDelete}
                >
                    <p>
                        <span style={{ fontWeight: 600 }}>{this.props.alertDialog.boldText ? this.props.alertDialog.boldText : strings.Warning} {!this.props.alertDialog.boldText ? " : " : null}</span> {this.props.alertDialog.description}
                    </p>

                    {
                        this.props.alertDialog.textFieldLabel ?
                            <Inputs field={{
                                type: "textfield",
                                title: this.props.alertDialog.textFieldLabel,
                                error: this.state.temporaryElement.name === "",
                                value: this.state.textField,
                                onChange: (e) => {
                                    this.setState({ textField: e.target.value });
                                }
                            }}/>
                            : null
                    }
                </Modal>
            </Dialog>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(ActionsCreators, dispatch);
};

export default connect(
    (state) => state,
    mapDispatchToProps
)(AlertDialog);
